// Conversion events for the marketing site.
//
// The vendor loaders (PostHog, GA4, Meta Pixel) live in
// src/_partials/_analytics.erb and handle pageviews on their own. This file
// only adds the two things a static marketing site can't infer from pageviews:
// clicks through to the app, and a completed contact form.
//
// Every call is guarded — `window.__spAnalytics` is false off *.statspresso.com,
// and an ad blocker can null out any individual vendor even when it's true.

const APP_ORIGIN = "https://app.statspresso.com"

function track(event, props = {}) {
  if (!window.__spAnalytics) return

  if (window.posthog) window.posthog.capture(event, props)
  if (window.gtag) window.gtag("event", event, props)
}

// Clicks on any link into the app: the primary conversion on this site.
// Delegated on document so it covers the navbar, hero, and every in-page CTA
// without touching their markup.
document.addEventListener("click", (event) => {
  const link = event.target.closest(`a[href^="${APP_ORIGIN}"]`)
  if (!link) return

  // Where on the page the CTA sits, so "nav Start Free Trial" can be told apart
  // from the same words in the footer or a mid-page block.
  let placement = "body"
  if (link.closest("header, nav")) placement = "nav"
  else if (link.closest("footer")) placement = "footer"

  track("app_cta_click", {
    cta_text: link.innerText.trim().slice(0, 80),
    cta_placement: placement,
    cta_href: link.href,
    page_path: location.pathname,
  })

  if (window.fbq) window.fbq("track", "Lead", { content_name: "app_cta_click" })
})

// The contact form posts to functions/contact.js, which 303-redirects to
// /contact-us/thank-you on success. That redirect is the only reliable signal
// the submission actually cleared Turnstile, so fire the event on arrival
// rather than on submit.
if (location.pathname.replace(/\/$/, "") === "/contact-us/thank-you") {
  track("contact_form_submitted", { page_path: location.pathname })
  if (window.fbq) window.fbq("track", "Contact")
}
